const title = 'Confirm Removal';
export default title;
